import React from 'react';
import { Link } from 'react-router-dom';
import styles from './DemoBanner.module.css';

const DemoBanner: React.FC = () => (
  <div className={styles.banner}>
    <span className={styles.icon}>&#x1f512;</span>
    <span>
      You&apos;re viewing <strong>demo data</strong>.
    </span>
    <Link to="/login" className={styles.cta}>
      Sign in for live access
    </Link>
  </div>
);

export default DemoBanner;
